/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Done_Subscribed_HInputs */

const en_funnel_done_subscribed_h = /** @type {(inputs: Funnel_Done_Subscribed_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have Premium.`)
};

const es_funnel_done_subscribed_h = /** @type {(inputs: Funnel_Done_Subscribed_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tienes Premium.`)
};

/**
* | output |
* | --- |
* | "You already have Premium." |
*
* @param {Funnel_Done_Subscribed_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_done_subscribed_h = /** @type {((inputs?: Funnel_Done_Subscribed_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Done_Subscribed_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_done_subscribed_h(inputs)
	return en_funnel_done_subscribed_h(inputs)
});